<template>
    <div class="username">
        <span class="username" :style="'color:#'+item.color+';'" @click="profileAction">
            {{ item.username }}
        </span>
    </div>
</template>
<script>
    export default {
        
        name: "Username",
        props: {
            item: { type: Object, required: true }
        },
        
        methods: {
            profileAction( event )
            {
                
                this.$core.f().skip( event )
                this.$core.ui()
                    .showUserProfile( this.$props.item.id_user || this.$props.item.id )
                
            }
        }
        
    }
</script>
<style scoped>
span.username{
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
</style>